import React, { useEffect, useState } from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Spinner,
  Stack,
  Radio,
  RadioGroup,
} from "@chakra-ui/react";

import { GetRoles } from "services/RolesService";

import { PatchUserDetailsUpdate } from "services/AdminUserManagementServices";

import check_icon from "assets/images/icons/check_icon.png";
import cross_icon from "assets/images/icons/cross_dark_icon.png";
import edit_icon_dark from "assets/images/icons/edit_icon_dark.png";

export default function EditUserModal(props) {
  const { isOpen, onClose, userDataProp, setCheckUpdate } = props;

  const [errorText, setErrorText] = useState("");

  const userData = userDataProp;

  const [firstName, setFirstName] = useState(userData?.first_name);
  const [lastName, setLastName] = useState(userData?.last_name);
  const [email, setEmail] = useState(userData?.user_email);
  const [userRole, setUserRole] = useState(userData?.user_role_id);
  const [isActive, setIsActive] = useState(userData?.is_active);

  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const [rolesList, setRolesList] = useState([]);

  const containsNumbers = (str) => /\d/.test(str);

  const validateInputs = () => {
    if (firstName === "" || containsNumbers(firstName)) {
      setErrorText("Invalid First Name");
      return false;
    }

    if (lastName === "" || containsNumbers(lastName)) {
      setErrorText("Invalid Last Names");
      return false;
    }

    if (email === "" || !/\S+@\S+\.\S+/.test(email)) {
      setErrorText("Invalid Email Address");
      return false;
    }

    if (userRole === "") {
      setErrorText("User Role is required");
      return false;
    }
    return true;
  };

  useEffect(() => {
    const fetch_roles = async () => {
      try {
        const response = await GetRoles();
        const roles_data = response.data;
        setRolesList(roles_data);
      } catch (error) {
        console.log(error);
      }
    };

    // fetch_roles();
  }, []);

  useEffect(() => {
    if (!userData) {
      return;
    }

    setFirstName(userData?.first_name);
    setLastName(userData?.last_name);
    setEmail(userData?.user_email);

    if (userData?.user_has_role?.length > 0) {
      setUserRole(userData?.user_has_role[0]?.role_id);
    }

    if (userData?.user_is_active) {
      setIsActive("1");
    } else {
      setIsActive("0");
    }
  }, [userData]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateInputs()) {
      return;
    }

    setLoadingSubmit(true);

    const formData = new FormData(event.target);
    formData.append("user_id", userData?.user_id);

    try {
      const response = await PatchUserDetailsUpdate(formData);

      setCheckUpdate((prev) => !prev);
      onClose();
    } catch (error) {
      setErrorText("Error: " + error.response.data.message);
    } finally {
      setLoadingSubmit(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <div className="flex flex-row gap-2 ml-2">
            <div className="h-6 w-6  flex flex-col justify-center ">
              <img src={edit_icon_dark} />
            </div>

            <h4>Edit User</h4>
          </div>
          {!loadingSubmit && <ModalCloseButton />}
        </ModalHeader>

        <form onSubmit={handleSubmit}>
          <ModalBody sx={{ padding: "2rem" }}>
            <div className="mb-2 flex flex-col gap-6 ">
              <div className="ml-2.5">
                <p className="text-red-500 font-bold">{errorText}</p>
              </div>
              <div className="flex  flex-col gap-6 md:flex-row justify-between">
                <div className="md:w-[16rem]">
                  <p className="label">First Name</p>
                  <Input
                    name="first_name"
                    type="text"
                    className="input"
                    placeholder="Enter First Name"
                    isInvalid={errorText?.toLowerCase()?.includes("first")}
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                <div className="md:w-[16rem]">
                  <p className="label">Last Name</p>
                  <Input
                    name="last_name"
                    type="text"
                    className="input"
                    placeholder="Enter Last Name"
                    isInvalid={errorText?.toLowerCase()?.includes("last")}
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
              </div>
              {/* <div className="md:w-[32rem]">
                <p className="label">Email</p>
                <Input
                  name="email"
                  type="text"
                  className="input"
                  placeholder="abc@example.com"
                  isInvalid={errorText?.toLowerCase()?.includes("email")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div> */}

              <div className="md:w-[33rem]  ">
                <p className="label">Select Status</p>
                <RadioGroup
                  name="isActive"
                  isInvalid={errorText}
                  value={isActive}
                  onChange={setIsActive}
                >
                  <Stack direction="row">
                    <Radio value={"1"}>Active</Radio>
                    <Radio value={"0"}>Inactive</Radio>
                  </Stack>
                </RadioGroup>
              </div>
            </div>
            <ModalFooter>
              <div className="flex flex-row justify-end w-full  ">
                <div className="w-fit h-[3.13rem] flex flex-col justify-center ">
                  <Button
                    variant="ghost"
                    isDisabled={loadingSubmit}
                    sx={{ height: "3.13rem" }}
                    onClick={onClose}
                  >
                    <>
                      <img className="mr-2" src={cross_icon} />
                      Cancel
                    </>
                  </Button>
                </div>
                <div className="w-[10rem] h-[3.13rem]">
                  <Button
                    type="submit"
                    variant="solid"
                    isDisabled={loadingSubmit}
                    sx={{ height: "3.13rem" }}
                  >
                    {loadingSubmit ? (
                      <Spinner />
                    ) : (
                      <>
                        <img className="mr-2" src={check_icon} />
                        Save Changes
                      </>
                    )}
                  </Button>
                </div>
              </div>
            </ModalFooter>
          </ModalBody>
        </form>
      </ModalContent>
    </Modal>
  );
}
